import { toQueryString } from '@croquiscom/web2app';

import { gotoLogin } from '@common/utils';
import { useAuthenticationState } from '@widgets/authentication';
import { Router, useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useCreatorCouponService = () => {
  const params = useCatalogProductIdParams();
  const utm_source = params.utm_source;

  const { authState } = useAuthenticationState();
  const {
    product: {
      product_price: {
        coupon_button_color: { normal: coupon_button_of_atf },
      },
    },
  } = usePdpBaseInfo(params);

  const moveToCouponRegisterPage = () => {
    const coupon_issue_url = `/checkout/coupon/issue?${toQueryString({
      from: 'pdp',
    })}`;

    if (authState === 'failed') {
      gotoLogin({ redirect_url: coupon_issue_url });
      return;
    }

    Router.open(coupon_issue_url);
  };

  const should_hide_creator_coupon = utm_source !== 'youtube';

  return {
    should_hide_creator_coupon,
    button_color: coupon_button_of_atf,
    moveToCouponRegisterPage,
  };
};
